:host {
  --vx-atcc-background-color: var(--vx-add-to-cart-count__color, #00859B) ;
}

.vx-add-to-cart-count {
  font-family: "Open Sans", sans-serif;
  position: relative;
  height: 44px;
  width: 44px;
  overflow: hidden;
  background-color: #fff;
  border-radius: var(--vx-add-to-cart-count__border-radius, 8px);
  border: 1px solid var(--vx-atcc-background-color);
  transition: width 0.3s ease;
  isolation: isolate;
}
.vx-add-to-cart-count button {
  border: none;
}
.vx-add-to-cart-count button:focus {
  outline: none;
}
.vx-add-to-cart-count:not(.vx-add-to-cart-count--disabled) {
  cursor: pointer;
}
.vx-add-to-cart-count:not(.vx-add-to-cart-count--disabled):focus-within {
  outline: 3px solid var(--ci-primary600);
  outline-offset: -1px;
}

* {
  box-sizing: border-box;
}

.vx-add-to-cart-count__sub,
.vx-add-to-cart-count__number,
.vx-add-to-cart-count__add {
  width: 44px;
  height: 100%;
  line-height: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  z-index: 2;
}
.vx-add-to-cart-count:not(.vx-add-to-cart-count--disabled) .vx-add-to-cart-count__sub:not(:disabled):not(.vx-add-to-cart-count__add--disabled),
.vx-add-to-cart-count:not(.vx-add-to-cart-count--disabled) .vx-add-to-cart-count__number:not(:disabled):not(.vx-add-to-cart-count__add--disabled),
.vx-add-to-cart-count:not(.vx-add-to-cart-count--disabled) .vx-add-to-cart-count__add:not(:disabled):not(.vx-add-to-cart-count__add--disabled) {
  cursor: pointer;
}

.vx-add-to-cart-count__sub {
  border-right: 1px solid var(--vx-atcc-background-color);
  transition: background-color 0.3s ease;
  left: 0;
  user-select: none;
  cursor: pointer;
}
.vx-add-to-cart-count__sub--one {
  z-index: 5;
  background-color: var(--vx-atcc-background-color);
}
.vx-add-to-cart-count__sub:hover {
  background-color: var(--vx-atcc-background-hover-color, #006B7E);
}
.vx-add-to-cart-count__sub:active {
  background-color: var(--vx-atcc-background-hover-color, #00505E);
}

.vx-add-to-cart-count__number {
  border-right: 1px solid var(--vx-atcc-background-color);
  left: 45px;
}
.vx-add-to-cart-count__number > input {
  font-size: 16px;
  width: 100%;
  height: 44px;
  text-align: center;
  border: 0;
  /* Chrome, Safari, Edge, Opera */
  /* Firefox */
}
.vx-add-to-cart-count__number > input::-webkit-outer-spin-button, .vx-add-to-cart-count__number > input::-webkit-inner-spin-button {
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-appearance: none;
  margin: 0;
}
.vx-add-to-cart-count__number > input[type=number] {
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -moz-appearance: textfield;
}
.vx-add-to-cart-count__number > input:focus {
  outline: none;
}

.vx-add-to-cart-count__add {
  background-color: var(--vx-atcc-background-color);
  transition: background-color 0.3s ease;
  right: 0;
  user-select: none;
}
.vx-add-to-cart-count__add:hover {
  background-color: var(--vx-atcc-background-hover-color, #006B7E);
}
.vx-add-to-cart-count__add:active {
  background-color: var(--vx-atcc-background-hover-color, #00505E);
}

.vx-add-to-cart-count--open {
  width: 132px;
}

.vx-add-to-cart-count--disabled {
  cursor: not-allowed;
  border-color: #4a4a4a;
}

.vx-add-to-cart-count__sub--disabled,
.vx-add-to-cart-count__add--disabled {
  background-color: #ECECEC;
  cursor: not-allowed;
}
.vx-add-to-cart-count__sub--disabled:hover,
.vx-add-to-cart-count__add--disabled:hover {
  background-color: #ECECEC;
}
.vx-add-to-cart-count__sub--disabled:active,
.vx-add-to-cart-count__add--disabled:active {
  background-color: #ECECEC;
}